module.exports = __webpack_public_path__ + "static/media/course01.acdcb857.jpeg";